<app-header>
  @if (showBreadcrumbs()) {
    <bit-breadcrumbs slot="breadcrumbs">
      <bit-breadcrumb [route]="['/settings']" icon="bwi-cog">{{
        "settings" | i18n
      }}</bit-breadcrumb>
      <bit-breadcrumb [route]="[]" queryParamsHandling="preserve">{{
        "addPlan" | i18n
      }}</bit-breadcrumb>
    </bit-breadcrumbs>
  }
</app-header>

<bit-container>
  <p>{{ "newOrganizationDesc" | vfo1I18n: "addPlanDesc" }}</p>
  <app-org-info [formGroup]="formGroup" [createOrganization]="true"></app-org-info>
  <button
    type="button"
    bitButton
    buttonType="primary"
    [disabled]="busy || formGroup.invalid"
    (click)="submit()"
  >
    {{ "newOrganization" | i18n }}
  </button>
</bit-container>
